export default "__VITE_ASSET__CWO2FigC__"